@use 'themes/westfield' as *;
@use 'tools/browser' as *;
@use 'tools/color' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;
@use 'tools/typography.module' as *;

.siteFooter {
  background-color: #fff6ed;
  color: #1c1f24;
  position: relative;
  padding: 0;
}

.brand {
  &::after {
    background: color('Brand');
  }
}

.seasonal {
  &::after {
    background: color('Seasonal');
  }
}

.container {
  margin: 0 auto;
  padding: units(2) units(3) units(3);
  max-width: 1152px;

  @include breakpoint('tablet') {
    padding: units(2) units(1.25);
  }
}

.banner {
  height: 32px;
  background: #da291c;
}

.showAngle .container {
  padding: columns(1) units(3);

  @include breakpoint('tablet') {
    padding: units(3) units(1.5) units(1.5);
  }
}

.content {
  flex-direction: column;
  gap: 32px;

  @include breakpoint('tablet') {
    gap: 24px;
  }
}

.logo {
  width: units(6);
  height: units(2);
}

.showAngle .logo {
  margin-bottom: units(1);
}

.linksList {
  @extend .bodyFont;
  display: flex;
  flex-flow: wrap column;
  gap: units(2);
  margin-top: units(0.5);

  > * {
    margin: units(1) units(1) 0 0;
  }

  @include fromBreakpoint('tablet') {
    flex-direction: row;
    justify-content: flex-start;
    gap: 0;

    > * {
      margin-top: 0;
    }
  }
}

.footerLink {
  @extend .bodyFont;

  @include font-size(1);
  color: #1c1f24;
  line-height: normal;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.rightsText {
  line-height: normal;
  margin-top: 0;

  @include breakpoint('tablet') {
    margin-top: units(1.5);
  }
}

.rightsTextLink {
  text-decoration: underline;
}

.disclaimer {
  line-height: units(1.25);

  a {
    color: #1c1f24;
  }
}
